import {
  DEFAULT_PATCH_APPLY_STATUS_META,
  PATCH_APPLY_REASON_LABELS,
  PATCH_APPLY_STATUS_META,
  PATCH_APPLY_TAB_LABELS,
} from './messagePatchApplyStatusConfig.js';

function isRecord(value) {
  return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
}

function resolveRecord(value) {
  return isRecord(value) ? value : {};
}

function resolveList(value) {
  return Array.isArray(value) ? value : [];
}

function resolveDisplayText(value) {
  if (typeof value === 'string' || typeof value === 'number') {
    return String(value).trim();
  }
  return '';
}

function appendUniqueText(values, item) {
  const value = resolveDisplayText(item);
  if (!value || values.includes(value)) {
    return values;
  }
  return [...values, value];
}

function uniqueTexts(items) {
  return items.reduce(appendUniqueText, []);
}

function resolveTargetTabs(payload) {
  return uniqueTexts([
    ...resolveList(payload?.target_tabs),
    ...resolveList(payload?.applied_tabs),
    ...resolveList(payload?.failed_tabs),
  ]);
}

function resolveTargetText(tabs) {
  return tabs
    .map((tab) => PATCH_APPLY_TAB_LABELS[tab] ?? tab)
    .filter(Boolean)
    .join(' / ');
}

function resolveReasonText(reason) {
  return PATCH_APPLY_REASON_LABELS[resolveDisplayText(reason)] ?? '';
}

function resolveSummary({ description, reasonText, targetText }) {
  return [
    description,
    targetText ? `：${targetText}` : '',
    reasonText ? `（${reasonText}）` : '',
  ].join('');
}

export function resolvePatchApplyStatusViewModel(value) {
  const payload = resolveRecord(value);
  const status = resolveDisplayText(payload?.status);
  if (!status) {
    return null;
  }

  const meta = PATCH_APPLY_STATUS_META[status] ?? DEFAULT_PATCH_APPLY_STATUS_META;
  const targetTabs = resolveTargetTabs(payload);
  const targetText = resolveTargetText(targetTabs);
  const reasonText = resolveReasonText(payload?.reason);
  const description = meta.description;

  return {
    status,
    title: resolveDisplayText(payload?.title) || meta.title,
    description,
    reasonText,
    targetTabs,
    targetText,
    summary: resolveSummary({ description, reasonText, targetText }),
    tone: meta.tone,
    iconKind: meta.iconKind,
    color: meta.color,
    borderColor: meta.borderColor ?? '',
  };
}
